import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";

const ReassignModal = (props) => {
  const [formData, setFormData] = useState({
    reason: "",
    name: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const errs = {};
    const { reason, name, email } = formData;

    if (!reason.trim()) {
      errs.reason = constantMessages.reasonRequired;
    } else if (reason.trim().length < 3 || reason.trim().length > 200) {
      errs.reason = constantMessages.largeStringLengthError;
    }

    if (!name.trim()) {
      errs.name = "Name is required.";
    }

    if (!email.trim()) {
      errs.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errs.email = "Invalid email format.";
    }

    setErrors(errs);
    return errs;
  };

  const handleSubmit = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) return;

    const reassignData = {
      forwardedTo: {
        name: formData.name,
        email: formData.email,
      },
      reason: formData.reason,
    };

    props.handleSubmit(reassignData);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      reason: "",
      name: "",
      email: "",
    });
    setErrors({});
    props.setIsReassignModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: null });
  };

  return (
    <Modal show={props.isModalOpen} onHide={resetForm} backdrop="static">
      <div className="modal-header">
        <h4 className="modal-title">Forward</h4>
        <button type="button" className="btn-close" onClick={resetForm}></button>
      </div>

      <div className="modal-body">
        <form>
          <div className="form-group mt-3">
            <label className="pb-2 input-date">
              Remark <span className="star-mark">*</span>
            </label>
            <textarea
              cols="40"
              rows="4"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              onBlur={validateForm}
              placeholder="Enter your reason here..."
              className="form-control"
            ></textarea>
            <p className="success-message">
              {checkCharacterLeft(formData.reason)} Characters left
            </p>
            {errors.reason && (
              <span className="error-message">{errors.reason}</span>
            )}
          </div>

          <div className="form-group mt-4">
            <label className="pb-2 input-date">
              Forward To <span className="star-mark">*</span>
            </label>
            <div className="row">
              <div className="col-md-6">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  className="form-control"
                />
                {errors.name && (
                  <span className="error-message">{errors.name}</span>
                )}
              </div>
              <div className="col-md-6">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="form-control"
                />
                {errors.email && (
                  <span className="error-message">{errors.email}</span>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          onClick={handleSubmit}
          className="Mom-btn btn btn-secondary bg-primary border-primary"
        >
          <p>Forward</p>
        </button>
      </div>
    </Modal>
  );
};

export default ReassignModal;
